import React, { useEffect, useState } from "react";
import { useProSidebar } from "react-pro-sidebar";
import { Link } from "react-router-dom";

const NavHeader = () => {
  const [toggleBtn, setToggleBtn] = useState({
    mainWrapper: "",
    hamburgerCls: "",
  });
  const { collapseSidebar } = useProSidebar();
  const hamburgerBtnHandler = () => {
    collapseSidebar();
    const getId = document.getElementById("main-wrapper");
    if (getId.classList.contains("menu-toggle")) {
      setToggleBtn({ mainWrapper: "", hamburgerCls: "" });
      return;
    }
    setToggleBtn({
      mainWrapper: "menu-toggle",
      hamburgerCls: "is-active",
    });
  };

  useEffect(() => {
    if (toggleBtn.mainWrapper === "menu-toggle") {
      document
        .getElementById("main-wrapper")
        .classList.add(toggleBtn.mainWrapper);
      // const sideBarArr = Array.from(
      //   document.getElementsByClassName(
      //     "side-navigation-panel-select-option-text"
      //   )
      // );
      // sideBarArr.map((val) => val.remove());
    } else {
      document.getElementById("main-wrapper").classList.remove("menu-toggle");
    }
  }, [toggleBtn.mainWrapper]);

  return (
    <React.Fragment>
      <div className="nav-header">
        <Link to="/admin/dashboard" className="brand-logo">
          <img
            src={
              process.env.REACT_APP_IMAGE_URL +
              "admin-images/" +
              "1673337591957.png"
            }
            alt={process.env.REACT_APP_MAIN_DOMAIN}
            width={50}
            height={50}
          />
          <h1 style={{ marginLeft: "10px" }}>The Bio</h1>
        </Link>
        <div className="nav-control">
          <div
            className={`hamburger ${toggleBtn.hamburgerCls}`}
            onClick={hamburgerBtnHandler}
          >
            <span className="line" />
            <span className="line" />
            <span className="line" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NavHeader;
